// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"SM-z","carouselContainer":"TM-z"};